export function resolveWizardWorkerApiBase(): string {
  const baseUrl = import.meta.env.VITE_WORKER_API_BASE_URL;
  
  if (typeof baseUrl !== 'string' || baseUrl.trim() === '') {
    // Empty base means relative same-origin API
    return '';
  }

  // Strict environment-safe API base resolution
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const isLocalOrigin = 
    host === 'localhost' || 
    host === '127.0.0.1' || 
    host === '::1' || 
    host === '0.0.0.0';

  if (!isLocalOrigin) {
    // Force same-origin relative paths for production core APIs
    // Browser core flow must never call legacy external workers
    return '';
  }

  // Remove trailing slashes to prevent double slashes in paths
  return baseUrl.replace(/\/+$/, '');
}

export function buildApiUrl(endpoint: string): string {
  const base = resolveWizardWorkerApiBase();
  if (base === null || base === undefined) {
    return '';
  }
  
  // Ensure endpoint starts with slash
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  // Security boundary: browser must never call apt-licensing directly
  if (base.includes('apt-licensing') || path.includes('apt-licensing')) {
    console.warn('Security: Direct apt-licensing browser calls are forbidden.');
    return '';
  }
  
  return `${base}${path}`;
}
